import {
  ButtonBase,
  Grid,
  Typography,
} from '@mui/material';
import clsx from 'clsx';
import { Text } from 'components/text';
import { TitleWithValue } from 'components/title-with-value';
import { TFunction } from 'i18next';
import { memo } from 'react';
import { OrderProperty } from 'types/order';

import { useStyles } from './styles';
import { useInformationBar } from './use-information-bar';

interface Props {
  t: TFunction;
  properties: OrderProperty[],
  isOrderLoading: boolean,
}

const InformationBar = ({
  t,
  properties,
  isOrderLoading
}: Props) => {
  const classes = useStyles();
  const {
    selectedProperty,
    selectProperty
  } = useInformationBar({ properties });

  const sortedProperties = [...properties].sort((propertyA, propertyB) => (
    propertyA.address.address.localeCompare(propertyB.address.address)
  ));

  return (
    <>
      <Grid container direction="row" alignItems="flex-end" className={classes.container}>
        <Grid item xs={12} sm className={classes.propertyColumn}>
          <Grid container direction="column" className={classes.propertyList}>
            {sortedProperties.length > 0 ? sortedProperties.map((property) => (
              <Grid item key={property._id}>
                <ButtonBase
                  className={clsx(classes.propertyButton, {
                    [classes.propertyButtonSelected]: property.address.address === selectedProperty.address,
                  })}
                  onClick={() => selectProperty({ property })}
                >
                  <Typography variant="body2">{property.address.address}</Typography>
                </ButtonBase>
              </Grid>
            )) : <Typography variant="body2">{t('common:no-defined-yet')}</Typography>}
          </Grid>
        </Grid>
        {selectedProperty.purchasePrice ? (
          <Grid item xs={6} sm="auto" className={classes.amountColumn}>
            <TitleWithValue title={t('orders:purchase-price')} titleUppercase={false} isLoading={isOrderLoading}>
              <Text
                value={selectedProperty.purchasePrice}
                isMoney
                fontWeight="bold"
                style={{ fontFamily: 'monospace', fontVariantNumeric: 'tabular-nums', textAlign: 'right' }}
              />
            </TitleWithValue>
          </Grid>
        ) : null}
        {selectedProperty.loanAmount ? (
          <Grid item xs={6} sm="auto" className={classes.amountColumn}>
            <TitleWithValue title={t('orders:loan-amount')} titleUppercase={false} isLoading={isOrderLoading}>
              <Text
                value={selectedProperty.loanAmount}
                isMoney
                fontWeight="bold"
                style={{ fontFamily: 'monospace', fontVariantNumeric: 'tabular-nums', textAlign: 'right' }}
              />
            </TitleWithValue>
          </Grid>
        ) : null}
      </Grid>
    </>
  );
};

export default memo(InformationBar);
